<maced-header headerId="Header" [links]="headerlinks" logoImg="./assets/default/images/logo-mee-black-mac.svg" logoImgAltName="Macmillan Education Everywhere Platform"
  logoHyperLink="/" [logoWidth] = 36 [logoHeight] = 48>
</maced-header>